import { Settings } from "lucide-react";
import { Icon } from "@iconify/react";
import NewLoginPage from "../../pages/auth/LoginPage";
import { logoDarkImage } from "../../shared/images";
import { HStack } from "../../shared/utils";
import { DemoBookWrapper } from "../DemoBook";
import { FlyoutProfile } from "./components/FlyoutProfile";
import { useState } from "react";
import {
  CompanyType,
  SwitchCompanyDropdown,
} from "../Components/companyDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { SwitchProduct } from "./components/SwitchPlatform";
import { handleClickForTracking } from "../../analytics";
import { AnalyticsConstant } from "../../AnalyticsContant";
import { trackEvent } from "../../utils/AmpAnalytics";
import { useFeatureFlag } from "../../FeatureFlags";

export function TopBarComponent(props: any) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isDemoPage = pathname ? pathname?.split("/")?.includes("demo") : false;
  const isNonDashboardPage = ["/explore", "/demo", "/userProfile"].some((key) =>
    pathname?.includes(key)
  );

  return (
    <div className="fixed top-0 right-0 left-0 z-40 bg-white shadow-box">
      <div
        className={`flex h-14 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-6 ${props.className}`}
      >
        <div
          onClick={() => {
            if (isNonDashboardPage) {
              // handleClickForTracking(AnalyticsConstant.hissa_logo_button);
              trackEvent("Navigating to Dashboard");
              navigate("/landing/dashboard");
            }
          }}
        >
          {logoDarkImage ? (
            <img
              className={`h-9 mx-auto w-auto ${
                isNonDashboardPage ? "cursor-pointer" : ""
              }`}
              src={logoDarkImage}
              alt="hissa_logo"
            />
          ) : (
            <h2 className="text-4xl font-semibold text-secondary">{"hissa"}</h2>
          )}
        </div>
        <form className="relative flex flex-1" action="#" method="GET"></form>
        {isDemoPage && (
          <p
            className={`py-4 text-sm cursor-pointer hover:text-gray-700 text-gray-500`}
            onClick={() => {
              navigate("/landing/dashboard");
              trackEvent("Navigating to Dashboard");
            }}
          >
            {"Dashboard"}
          </p>
        )}
        {!isDemoPage && (
          <p
            className={`py-4 text-sm cursor-pointer hover:text-gray-700 ${
              isDemoPage
                ? "text-secondary border-b-2 border-secondary"
                : "text-gray-500"
            }`}
            onClick={() => {
              // handleClickForTracking(AnalyticsConstant.book_a_demo_button);
              trackEvent("Booking a Demo");
              navigate("/landing/demo");
            }}
          >
            {"Book a Demo"}
          </p>
        )}

        {/* <SwitchCompanyDropdown
          data={demoCompanies}
          selectedCompany={selectedCompany}
          setSelectedCompany={(company: any) => {
            setSelectedCompany(company);
          }}
        /> */}
        {/* <div
          className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
          aria-hidden="true"
        /> */}

        {/* <div className="md:block">
          <Settings className="text-gray-600 cursor-pointer transition-transform duration-500 hover:rotate-45" />
        </div> */}
        <div className="md:block">
          <SwitchProduct />
        </div>
        <div className="md:block">
          <FlyoutProfile />
        </div>
      </div>
    </div>
  );
}

export function LoginPageTopBar(props: any) {
  const isMarketplace = useFeatureFlag("allowUserRegistration");

  return (
    <>
      {!isMarketplace && (
        <div className="fixed top-0 right-0 left-0 z-40 bg-white shadow-box">
          <div
            className={`flex h-14 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-6 ${props.className}`}
          >
            {logoDarkImage ? (
              <img
                className="h-9 mx-auto w-auto"
                src={logoDarkImage}
                alt="hissa_logo"
              />
            ) : (
              <h2 className="text-4xl font-semibold text-secondary">
                {"hissa"}
              </h2>
            )}
            <form
              className="relative flex flex-1"
              action="#"
              method="GET"
            ></form>
            <div className="hidden lg:block"></div>
            <HStack className="gap-4 md:gap-8">
              <p
                className={`py-4 cursor-pointer ${
                  props.selectedTab === "login"
                    ? "text-secondary border-b-2 border-secondary"
                    : "text-gray-500"
                }`}
                onClick={() => {
                  props.setSelectedTab("login");
                }}
              >
                Log In
              </p>
              <p
                className={`py-4 cursor-pointer ${
                  props.selectedTab === "demo"
                    ? "text-secondary border-b-2 border-secondary"
                    : "text-gray-500"
                }`}
                onClick={() => {
                  // handleClickForTracking(AnalyticsConstant.book_a_demo_button);
                  trackEvent("Booking a Demo");
                  props.setSelectedTab("demo");
                }}
              >
                Book a Demo
              </p>
            </HStack>
          </div>
          {props.selectedTab === "login" && <NewLoginPage />}
          {props.selectedTab === "demo" && <DemoBookWrapper />}
        </div>
      )}
      {isMarketplace && <NewLoginPage />}
    </>
  );
}
